import { setDefaultEnvironment } from '@adsk/ha-adp-dotcom-logger-util';
import { defaultLanguageCountry } from '@adsk/ha-beehive-connector-util/lib/BeehiveUtils/data-helpers';
import { PropTypes } from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { ENVIRONMENT } from '../constants';
import EnvContext from '../envContext';
import useScript from '../../utils/hooks/useScript';

const SearchMFELoader = ({ product, variant }) => {
  const envContext = useContext(EnvContext);
  const env = envContext[ENVIRONMENT];
  const language = envContext.LANGUAGE || defaultLanguageCountry;
  const [readySearchMfe, setReadySearchMfe] = useState(false);
  const [loadedSearchMfe, setLoadedSearchMfe] = useState(false);

  // Append Search MFE CSS & Js.
  const mfeEnv = setDefaultEnvironment();
  const searchMfeUrl = `https://app.digital-help-${mfeEnv}.autodesk.com/etx-search-mfe/current/static/js/main.js`;
  const searchMfeStatus = useScript(searchMfeUrl);

  const loadSearchCFP = () => {
    if (window && window.cfp !== undefined) {
      window.etx = window.etx || {};
      if (window.cfp.providers) {
        window.cfp.providers.communication.unregister('etxSearchMfeCfp');
      }

      if (document.getElementById('etx-search-root').innerHTML === '') {
        window.cfp.providers.integration.mount(
          window.cfp.mfe.etxSearchMfeCfp,
          document.getElementById('etx-search-root'),
          {
            variant,
            // supportPage | productPage | fullSearchPage
            env,
            product,
            language
          }
        );
      }
      setLoadedSearchMfe(true);
    }
    return () => {
      if (window.cfp !== undefined)
        window.cfp.providers.integration.unmount(
          window.cfp.mfe.etxSearchMfeCfp
        );
    };
  };

  if (readySearchMfe && !loadedSearchMfe) {
    const head = document.getElementsByTagName('head')[0];
    const searchCss = document.createElement('link');
    searchCss.rel = 'stylesheet';
    searchCss.type = 'text/css';
    searchCss.href = `https://app.digital-help-${mfeEnv}.autodesk.com/etx-search-mfe/current/static/css/main.css`;
    head.appendChild(searchCss);
    loadSearchCFP();
  }

  useEffect(() => {
    if (searchMfeStatus === 'ready') {
      setReadySearchMfe(true);
    }
  }, [searchMfeStatus]);

  return <div id="etx-search-root" data-testid="etx-search-root" />;
};

SearchMFELoader.propTypes = {
  /**
   * The product to search for
   */
  product: PropTypes.string,
  variant: PropTypes.string.isRequired
};

SearchMFELoader.defaultProps = {
  /**
   * Default product
   */
  product: ''
};
export default SearchMFELoader;
